 <template>
  <el-row class="el-row_h">
    <el-col :span="24">
      <div class="grid-content bg-purple-dark layout_box flex s_bg" style="overflow: auto;">
        <el-input style="min-width: 150px;" placeholder="请输入用户关键字搜索" v-model="keyWord" clearable size="small" class="s_padding filterSelect">
        </el-input>
        <dateRangeHis ref="dateRange"></dateRangeHis>

        <el-select v-model="moneyD" size="small" placeholder="请选择资金方向" class="s_padding" style="width:80px;min-width: 80px">
          <el-option v-for="item in MoneyDe" :key="item.Code" :label="item.label" :value="item.Code">
          </el-option>
        </el-select>
        <el-select v-model="State" size="small" placeholder="请选择" class="s_padding" style="width:100px;min-width: 100px;">
          <el-option v-for="item in States" :key="item.Code" :label="item.Name" :value="item.Code">
          </el-option>
        </el-select>
        <el-select v-model="sortType" size="small" placeholder="请选择排序方式" class="s_padding" style="width:80px; min-width: 80px;">
          <el-option v-for="item in sortTypes" :key="item.Code" :label="item.label" :value="item.Code">
          </el-option>
        </el-select>
        <el-button type="primary" icon="el-icon-search" size="small" @click="getList()">查询</el-button>
      </div>
      <div style="height: 100%;">
        <tableCom :data="delegateList" v-loading="loading"></tableCom>
      </div>
      <div class="pagination_mb2 text-center">
        <pagination :pagerPro="Pager" @ee="pageFn"></pagination>
      </div>
      <div class="footer grid-content bg-purple layout_box">
        <span class="text-right">
          <span v-if="moneyD == 1">入金合计:
            <span class="capital">{{SubAccountLimit ? totalCapital : "***"}}</span>
            <span class="Currency"> ({{CurrencyName}})</span>
          </span>
          &nbsp;&nbsp;&nbsp;
          <span v-if="moneyD == 2">
            提现合计:
            <span class="capital">{{SubAccountLimit ? totalCurrency : "***"}}</span>
            <span class="Currency"> ({{CurrencyName}})</span>
          </span>
        </span>
      </div>
    </el-col>
  </el-row>
</template>
<script>
import tableCom from "./StatisticsWithChargeT.vue";
import pagination from "../../../paging.vue";
import dateRangeHis from "../../../dateRangeSubHis.vue";

export default {
  // 筛选器
  name: "positionDetailS",
  components: {
    tableCom,
    pagination,
    dateRangeHis
  },
  props: ["agentID"],
  data() {
    return {
      loading: "",
      sortType: 0,
      sortTypes: [{ Code: 0, label: "升序" }, { Code: 1, label: "降序" }],
      Pager: {
        PageNo: 1,
        PageSize: 10,
        RecordCount: 0
      },
      delegateList: [],
      totalCapital: 0,
      totalCurrency: 0,
      PositionEffectValue: "",
      PositionEffectList: [
        { Code: 0, Name: "全部" },
        { Code: 1, Name: "开仓" },
        { Code: 2, Name: "平仓" },
        { Code: 3, Name: "平开" }
      ],
      keyWord: "",
      moneyD: 1,
      MoneyDe: [{ Code: 2, label: "出金" }, { Code: 1, label: "入金" }],
      State: 0,
      States: [
        { Code: 0, Name: "成功" },
        { Code: 1, Name: "待审核" },
        { Code: 2, Name: "其他" }
      ],
      SubAccountLimit: true,
      CurrencyName: '',
    };
  },
  mounted() {
     if (sessionStorage.getItem("type") == "1"){
      if (sessionStorage.getItem("SubAccountLimit") != null && sessionStorage.getItem("SubAccountLimit") != "undefined") {
        this.SubAccountLimit = JSON.parse(sessionStorage.getItem("SubAccountLimit"));
      }
    }
    this.getList();
    this.getCurrencyName();
  },
  methods: {
    getCurrencyName() {
      var url = "/Account/GetInsBasicCurrency";
      var post = "";
      this.$loginapi.post(url, post, response => {
        if (response.Ret == 0) {
          this.CurrencyName = response.Data.Name;
        } else {
          this.$alert(response.Msg, {});
        }
      });
    },
    getList(isSearch = true) {
      if (isSearch) {
        this.Pager = {
          PageNo: 1,
          PageSize: 20,
          RecordCount: 0
        };
      }
      this.queryobj={
        UserKey:this.keyWord,
        BeginTime: this.$refs.dateRange.DateRangeValue[0],
        EndTime: this.$refs.dateRange.DateRangeValue[1],
        SortType: this.sortType,
        MoneyTransType: this.moneyD,
        State: this.State
      }
      this.$emit("withCharge", this.queryobj);
      this.loading = true;
      let url = "/report/QryAgentUserHistoryMoneyTransferStatistical";
      let postData = {
        AgentIds: this.agentID,
        UserKey: this.keyWord,
        BeginTime: this.$refs.dateRange.DateRangeValue[0],
        EndTime: this.$refs.dateRange.DateRangeValue[1],
        SortType: this.sortType,
        MoneyTransType: this.moneyD,
        State: this.State
      };
      this.$loginapi.postWithPage(
        url,
        this.Pager.PageNo,
        this.Pager.PageSize,
        postData,
        response => {
          this.loading = false;
          if (response.Ret == 0) {
            this.delegateList = response.Data.List;

            if (this.Pager.PageNo == 1) {
              this.totalCapital = response.Data.MoneyTransferTotal.EntityTotal;
              this.totalCurrency = response.Data.MoneyTransferTotal.OutTotal;
              this.Pager = response.Pager;
            }
          } else {
            this.$message.error(response.Msg);
          }
        }
      );
    },
    pageFn(size, PageNo) {
      this.Pager.PageSize = size;
      this.Pager.PageNo = PageNo;
      this.getList(false);
    }
  }
};
</script>

<style scoped>
.pagination_m {
  /* bottom: 20px !important; */
}
</style>



// WEBPACK FOOTER //
// src/components/selects/statics/StatisticsWithCharge/StatisticsWithChargeS.vue